import { Button, Icon, Modal } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';

interface Props {}

export interface FinancialBlockModalRef {
  openModal: () => void;
  closeModal: () => void;
}

export enum FinancialBlockErrors {
  FINANCIAL_BLOCK = 'FINANCIAL_BLOCK',
}

const FinancialBlockModal = forwardRef<FinancialBlockModalRef, Props>(
  (_, ref) => {
    const { t } = useTranslation(TranslationsKeys.OLD_TRANSLATIONS);
    const [modal, setModal] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal() {
        setModal(true);
      },
      closeModal() {
        setModal(false);
      },
    }));

    return (
      <Modal isOpen={modal} toggle={() => null}>
        <Container fluid className="text-center">
          <Icon name="warning" size={45} />
          <p className="h1 text-dark fs-20 mt-5 mb-5">
            {t('finishCourseRegistration.financialBlockModal.title')}
          </p>

          <p className="fs-16 lh-30 mt-3 mb-5">
            {t('finishCourseRegistration.financialBlockModal.body')}
          </p>

          <div className="d-flex justify-content-around" style={{ gap: 10 }}>
            <div className="flex-fill">
              <Button
                className="w-100"
                text={t('finishCourseRegistration.financialBlockModal.btn')}
                onClick={() => {
                  setModal(false);
                }}
              />
            </div>
          </div>
        </Container>
      </Modal>
    );
  },
);

export default FinancialBlockModal;
